// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"6c200777","714":"76d4ad74","777":"0d3f2336"}[chunkId] + ".chunk.js";
};